"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCheckbox = void 0;
var react_1 = __importStar(require("react"));
var react_client_1 = require("@speechly/react-client");
var utils_1 = require("../utils");
var VoiceCheckbox = function (_a) {
    var label = _a.label, value = _a.value, defaultValue = _a.defaultValue, intent = _a.intent, clearIntent = _a.clearIntent, setOnEntityType = _a.setOnEntityType, clearOnEntityType = _a.clearOnEntityType, onChange = _a.onChange, onFinal = _a.onFinal, onBlur = _a.onBlur, onFocus = _a.onFocus, _b = _a.focused, focused = _b === void 0 ? true : _b;
    var inputEl = react_1.useRef(null);
    var _c = react_1.useState(focused), _focused = _c[0], _setFocused = _c[1];
    var _d = react_1.useState(defaultValue !== undefined ? defaultValue : false), _value = _d[0], _setValue = _d[1];
    var _e = react_1.useState(defaultValue !== undefined ? defaultValue : false), _lastGoodKnownValue = _e[0], _setLastGoodKnownValue = _e[1];
    var _f = react_1.useState(undefined), lastSegmentId = _f[0], setLastSegmentId = _f[1];
    var segment = react_client_1.useSpeechContext().segment;
    var _onChange = function (newValue) {
        _setValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };
    var _onFocus = function () {
        _setFocused(true);
        // use callback only to change parent state
        if (!focused && onFocus) {
            onFocus();
        }
    };
    var _onBlur = function () {
        // use callback only to change parent state
        if (_focused) {
            _setFocused(false);
            if (onBlur) {
                onBlur();
            }
        }
    };
    react_1.useEffect(function () {
        if (focused && !_focused && inputEl != null && inputEl.current != null) {
            inputEl.current.focus();
        }
    }, [focused]);
    react_1.useEffect(function () {
        if (segment) {
            var newValue = null;
            var lastGoodKnownValue = _lastGoodKnownValue;
            // Update last good known value at new segment start
            var segmentId = segment.contextId + "/" + segment.id;
            if (segmentId !== lastSegmentId) {
                setLastSegmentId(segmentId);
                lastGoodKnownValue = value || _value;
                _setLastGoodKnownValue(lastGoodKnownValue);
            }
            // Define newValue if the segment contains input targeted to this component
            var clear = clearIntent && segment.intent.intent === clearIntent;
            var set = !clear && (!intent || segment.intent.intent === intent);
            if (set || clear) {
                var entities = utils_1.formatEntities(segment.entities);
                if (entities[setOnEntityType] !== undefined) {
                    newValue = set;
                }
                else if (clearOnEntityType && entities[clearOnEntityType] !== undefined) {
                    newValue = false;
                }
            }
            // _onChange to newValue only only if defined: tentative input may retarget to another component at any time
            // otherwise reset to last good known value
            _onChange(newValue !== null ? newValue : lastGoodKnownValue);
            if (segment === null || segment === void 0 ? void 0 : segment.isFinal) {
                if (inputEl != null && inputEl.current != null) {
                    inputEl.current.blur();
                }
                if (onFinal) {
                    onFinal();
                }
            }
        }
    }, [segment]);
    return (react_1.default.createElement("div", { className: "widgetGroup checkbox" },
        react_1.default.createElement("input", { type: "checkbox", checked: value !== undefined ? value : _value, onChange: function (event) { _onChange(event.target.checked); } }),
        react_1.default.createElement("label", null, label)));
};
exports.VoiceCheckbox = VoiceCheckbox;
//# sourceMappingURL=VoiceCheckbox.js.map